import useTranslation from 'next-translate/useTranslation';
import dynamic from 'next/dynamic';

// Hooks
import useAcl from '@/hooks/user/useAcl';
import useActiveTreeStructure from '@/utils/hooks/tree-structure/useActiveTreeStructure';

// Lib
import { aclFeatures } from '@/lib/acl/aclFeatures';

// Components
import Button from '@/components/base/Button';
const AddSocialProfilesFunnelModal = dynamic(
    () => import('@/components/composite/SocialProfiles/AddSocialProfilesFunnelModal')
);

// Types
import type { Dispatch, SetStateAction } from 'react';
import type { SocialProfileNetworkType } from '@/types/socialProfileType';

type AddSocialProfilesType = {
    isOpen: boolean;
    network: SocialProfileNetworkType;
    idSocialProfileAdded?: number;
};

type AddSocialProfilesActionProps = AddSocialProfilesType & {
    setState: Dispatch<SetStateAction<AddSocialProfilesType>>;
};

const AddSocialProfilesAction = ({
    isOpen,
    network,
    idSocialProfileAdded,
    setState
}: AddSocialProfilesActionProps) => {
    const { t } = useTranslation('socialprofiles');
    const { hasAcl } = useAcl();
    const { isTreeStructureActivated } = useActiveTreeStructure();

    if (!hasAcl(aclFeatures.social_profile.base.create)) {
        return null;
    }

    return (
        <>
            <Button
                size={isTreeStructureActivated ? 'sm' : 'md'}
                icon={isTreeStructureActivated ? 'plus-border' : 'plus'}
                className="mt-4 sm:mt-0"
                onClick={() => {
                    setState((prevState) => ({
                        ...prevState,
                        isOpen: true
                    }));
                }}>
                {t('add_social_profiles')}
            </Button>
            <AddSocialProfilesFunnelModal
                isOpen={isOpen}
                network={network}
                idSocialProfileAdded={idSocialProfileAdded}
                toggle={() => {
                    setState({
                        isOpen: false,
                        network: network
                    });
                }}
            />
        </>
    );
};

export default AddSocialProfilesAction;
